import { Action } from 'edocatbase/Global';
import constants from '../constants';

const { reducer: formModal } = window.Edocat.Components.ModalTest;

const reducer = (state = {}, action: Action) => {
  switch(action.type){
    case constants.ON_FORM_SUBMIT_PROMISE_ERROR: {
      //Matches 'org.alfresco...: 7575 message' sort of strings and removes everything except of the message.
      const regex = /org(\.\w+)+:\s(\d+\s)*/gi;
      const messageWithoutException = action.payload.replace(regex, '');
      return {
        ...state,
        responseModal: {
          isOpen: true,
          items: {
            text: messageWithoutException,
            severity: 'error',
            formInstanceId: action.meta?.formInstanceId,
          },
        },
      };
    }

    case constants.PROMISE_POST_TAG_ERROR: {
      return {
        ...state,
        responseModal: {
          isOpen: true,
          items: {
            text:
                window.Alfresco.messages.global[
                    action.payload?.message?.includes('exists') ? 'edocat.forms.tag-exists' : 'edocat.forms.tag-exists'
                    ],
            severity: 'error',
            formInstanceId: action.meta?.formInstanceId,
          },
        },
      };
    }

    default: {
      return formModal(state, action);
    }
  }
};

export default reducer;
